import React from 'react';

import { GridValidRowModel } from '@mui/x-data-grid';

import { ColumnDefinition } from 'components/Grid/types';

import UserCell from 'containers/Users/components/UserCell';

import AdminCell from './components/AdminCell';
import ActionCell from './components/ActionCell';

export const basicColumns = [
  {
    field: 'name',
    headerName: 'Name',
    valueGetter: (_value: unknown, row: GridValidRowModel) => ({ name: row.name, uuid: row.uuid }),
    renderCell: ({ value }: { value: { name: string; uuid: string } }) => (
      <UserCell name={value.name} uuid={value.uuid} />
    ),
    sortComparator: (v1: { name: string }, v2: { name: string }) => v1.name.localeCompare(v2.name),
    sortable: true,
  },
  {
    field: 'isAdmin',
    headerName: '',
    valueGetter: (_value: unknown, row: GridValidRowModel) => ({ isAdmin: row.isAdmin, uuid: row.uuid }),
    renderCell: ({ value, row }: { value: { isAdmin: boolean; uuid: string }; row: GridValidRowModel }) => (
      <AdminCell isAdmin={value.isAdmin} row={row} />
    ),
    sortable: false,
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: '',
    maxWidth: 50,
    ariaLabel: 'test',
    renderCell: ({ row }: { row: GridValidRowModel }) => <ActionCell rowData={row} />,
    sortable: false,
  },
] as unknown as ColumnDefinition[];
